import React, { Suspense } from 'react';

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';

const InterPlantTransferDialog = LazyLoadable(lazy(() => import('./inter-plant-transfer/dialog/InterPlantTransferDialog')));
const InterplantTransferCard = LazyLoadable(lazy(() => import("./inter-plant-transfer/InterPlantTransferCard")))


export const ROUTES_INTERPLANT = [
  {
    path: "/interplanttransfer/*",
    element: <Suspense fallback={<LoadingSpinner />}> <InterplantTransferCard /></Suspense>,
    children: [

      {
        path: "newtransfer",
        element: <InterPlantTransferDialog />
      },
      {
        path: ":id",
        element: <InterPlantTransferDialog />
      }

    ],
  },

];
